import React from 'react';
import PropTypes from 'prop-types';

import { Modal, Text } from '@olxbr/ds-web';
import User from '@olxbr/olx-icons/dist/System/User';
import Phone from '@olxbr/olx-icons/dist/System/Phone';
import WhatsApp from '@olxbr/olx-icons/dist/SocialMedia/Whatsapp';

import useContactModal from './useContactModal';
import { ContactWrapper, ContactsContainer, IconContainer, ActionButton } from './styles';
import { isMobile } from '../../../../../core/components/mobile-apps/service/mobile';

function ContactModal({ posData, isOpen, onClose }) {
  const contactModal = useContactModal(posData);

  return (
    <Modal open={isOpen} closeCallback={onClose} size="small" maxHeight={380} maxWidth={400}>
      <Text.TitleSmall>Quer um plano ainda maior?</Text.TitleSmall>
      <Text.BodyMedium>Converse com a nossa equipe de vendas de segunda a sexta das 09:00 às 18:00!</Text.BodyMedium>
      <ContactsContainer>
        <ContactWrapper>
          <IconContainer>
            <Phone color="orange" width={32} height={32} />
          </IconContainer>
          <Text.BodyMedium>Telefone</Text.BodyMedium>
        </ContactWrapper>
        <ActionButton
          size={isMobile ? 'small' : 'medium'}
          variant="secondary"
          onClick={contactModal.onClickPhone}
        >
          Ligar 0800 022 9800
        </ActionButton>
      </ContactsContainer>
      <ContactsContainer>
        <ContactWrapper>
          <IconContainer>
            <User color="purple" width={32} height={32} />
          </IconContainer>
          <Text.BodyMedium>A gente te liga</Text.BodyMedium>
        </ContactWrapper>
        <ActionButton
          size={isMobile ? 'small' : 'medium'}
          variant="secondary"
          onClick={contactModal.onClickSupport}
        >
          Enviar mensagem
        </ActionButton>
      </ContactsContainer>
      <ContactsContainer>
        <ContactWrapper>
          <IconContainer>
            <WhatsApp color="green"width={32} height={32} />
          </IconContainer>
          <Text.BodyMedium>WhatsApp</Text.BodyMedium>
        </ContactWrapper>
        <ActionButton
          size={isMobile ? 'small' : 'medium'}
          variant="secondary"
          onClick={contactModal.onClickWhatsApp}
        >
          Enviar mensagem
        </ActionButton>
      </ContactsContainer>
    </Modal>
  );
}

ContactModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  posData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ContactModal;
